import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DynamicManageService {
  // 获取流体类型列表
  static async getFluidType(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/fluid_type?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增流体类型
  static async addFluidType(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/basedata/fluid_type', payload))
    return Callback(err, res)
  }
  // 编辑流体类型
  static async editFluidType(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/basedata/fluid_type', payload))
    return Callback(err, res)
  }
  // 删除流体类型
  static async deleteFluidType(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/basedata/fluid_type', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取管道流向管理列表
  static async getPipeFlowList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/fluid_flow_direction/page?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增管道流向
  static async addPipeFlow(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/fluid_flow_direction/add', payload))
    return Callback(err, res)
  }
  // 编辑管道流向
  static async editPipeFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/fluid_flow_direction/modify', payload)
    )
    return Callback(err, res)
  }
  // 删除管道流向
  static async deletePipeFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/basedata/fluid_flow_direction', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 导出管道流向
  static async exportPipeFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/fluid_flow_direction/export', payload)
    )
    return Callback(err, res)
  }
  // 导入模板
  static async getPipeFlowTemplate() {
    const [err, res] = await To(wizStandardInstance.get('/api/fluid_flow_direction/template'))
    return Callback(err, res)
  }
  // 导入管道流向
  static async importPipeFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/fluid_flow_direction/import/${payload.documentId}`,
        payload.formData
      )
    )
    return Callback(err, res)
  }
}
